import React from "../_snowpack/pkg/react.js";
import "./SolarPanelPane.css";
import {OptimizationTarget} from "../constants.js";
const panelImage = "../assets/images/panel-monocrystaline.png";
const panelImageWebp = "../assets/images/panel-monocrystaline.webp";
const panelImageGreen = "../assets/images/panel-monocrystaline-green.png";
const panelImageWebpGreen = "../assets/images/panel-monocrystaline-green.webp";
const SolarPanel = (props) => {
  const image = props.panelType === OptimizationTarget.Money ? panelImage : panelImageGreen;
  const imageWebp = props.panelType === OptimizationTarget.Money ? panelImageWebp : panelImageWebpGreen;
  return /* @__PURE__ */ React.createElement("div", {
    className: "panel"
  }, /* @__PURE__ */ React.createElement("picture", null, /* @__PURE__ */ React.createElement("source", {
    type: "image/webp",
    srcSet: imageWebp
  }), /* @__PURE__ */ React.createElement("img", {
    src: image,
    alt: "solar panel"
  })), /* @__PURE__ */ React.createElement("div", {
    className: "numberOverlay"
  }, /* @__PURE__ */ React.createElement("span", {
    "aria-hidden": "true"
  }, props.index)));
};
const renderPanel = (panel) => {
  return /* @__PURE__ */ React.createElement(SolarPanel, {
    key: panel.index,
    index: panel.index,
    panelType: panel.panelType
  });
};
export const SolarPanelPane = (props) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "panelPane",
    style: {float: "right"}
  }, props.panels.map(renderPanel));
};
